import { createGlobalStyle} from "styled-components";

export const AutagendamientoStyles = createGlobalStyle`


  label.text-secondary {
    color: ${props => props?.extraStyle?.colorFont ? `${props?.extraStyle?.colorFont}!important` : "inherit"};
    font-size: ${props => props?.extraStyle?.fontSize ? `${props?.extraStyle?.fontSize}px!important` : "inherit"};
  }
`;